import { connect } from 'react-redux'
import Email from './email'
import {
  getUser,
  getUpdateAccountRequest
} from '../../../../stores/user/user.selectors'
import { updateUserEmail } from '../../../../stores/user/user.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = (state, { me }) => {
  const user = getUser(state)
  const updateAccountDetails = getUpdateAccountRequest(state)
  return {
    emailId: user.email_identity && user.email_identity.id,
    pending: updateAccountDetails.pending,
    email: user.email_identity && user.email_identity.email
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }) => ({
  ...stateProps,
  onSubmit: values => {
    const data = {
      new_email: values.email
    }
    dispatch(updateUserEmail(stateProps.emailId, data))
      .then(() =>
        toast.success(
          'We have just sent you a confirmation link to your new email address.'
        )
      )
      .catch(errorHandler)
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(Email)
